
<div id="notifyInfo" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-center">{{title | translate}}</h4>
        <button id="btnCloseNotify" type="button" class="ttp-btn-close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
      </div>
      <div class="modal-body">
        <p [innerHTML]="translateSrc | translate"></p>
      </div>
      <div class="modal-footer justify-content-center">
	  	<div class="col-12 col-lg-4">
        	<button id="notifyBtn" type="button" class="btn w-100 d-block btn-primary" data-bs-dismiss="modal">{{buttonText | translate}}</button>
      	</div>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->